// module.exports = new EBCDIC();

// const txt = [...map.entries()].map((e) => e.join(":")).join("/");

const ASCII_TABLE =
  "0:0/1:1/2:2/3:3/4:1A/5:9/6:1A/7:7F/8:1A/9:1A/0A:1A/0B:0B/0C:0C/0D:0D/0E:0E/0F:0F/10:10/11:11/12:12/13:13/14:1A/15:1A/16:8/17:1A/18:18/19:19/1A:1A/1B:1A/1C:1C/1D:1D/1E:1E/1F:1F/20:1A/21:1A/22:1A/23:1A/24:1A/25:0A/26:17/27:1B/28:1A/29:1A/2A:1A/2B:1A/2C:1A/2D:5/2E:6/2F:7/30:1A/31:1A/32:16/33:1A/34:1A/35:1A/36:1A/37:4/38:1A/39:1A/3A:1A/3B:1A/3C:14/3D:15/3E:1A/3F:1A/40:20/41:1A/42:1A/43:1A/44:1A/45:1A/46:1A/47:1A/48:1A/49:1A/4A:5B/4B:2E/4C:3C/4D:28/4E:2B/4F:21/50:26/51:1A/52:1A/53:1A/54:1A/55:1A/56:1A/57:1A/58:1A/59:1A/5A:5D/5B:24/5C:2A/5D:29/5E:3B/5F:5E/60:2D/61:1A/62:1A/63:1A/64:1A/65:1A/66:1A/67:1A/68:1A/69:1A/6A:7C/6B:2C/6C:25/6D:5F/6E:3E/6F:3F/70:1A/71:1A/72:1A/73:1A/74:1A/75:1A/76:1A/77:1A/78:1A/79:60/7A:3A/7B:23/7C:40/7D:27/7E:3D/7F:22/80:1A/81:61/82:62/83:63/84:64/85:65/86:66/87:67/88:68/89:69/8A:1A/8B:1A/8C:1A/8D:1A/8E:1A/8F:1A/90:1A/91:6A/92:6B/93:6C/94:6D/95:6E/96:6F/97:70/98:71/99:72/9A:1A/9B:1A/9C:1A/9D:1A/9E:1A/9F:1A/A0:1A/A1:7E/A2:73/A3:74/A4:75/A5:76/A6:77/A7:78/A8:79/A9:7A/AA:1A/AB:1A/AC:1A/AD:1A/AE:1A/AF:1A/B0:1A/B1:1A/B2:1A/B3:1A/B4:1A/B5:1A/B6:1A/B7:1A/B8:1A/B9:1A/BA:1A/BB:1A/BC:1A/BD:1A/BE:1A/BF:1A/C0:7B/C1:41/C2:42/C3:43/C4:44/C5:45/C6:46/C7:47/C8:48/C9:49/CA:1A/CB:1A/CC:1A/CD:1A/CE:1A/CF:1A/D0:7D/D1:4A/D2:4B/D3:4C/D4:4D/D5:4E/D6:4F/D7:50/D8:51/D9:52/DA:1A/DB:1A/DC:1A/DD:1A/DE:1A/DF:1A/E0:5C/E1:1A/E2:53/E3:54/E4:55/E5:56/E6:57/E7:58/E8:59/E9:5A/EA:1A/EB:1A/EC:1A/ED:1A/EE:1A/EF:1A/F0:30/F1:31/F2:32/F3:33/F4:34/F5:35/F6:36/F7:37/F8:38/F9:39/FA:1A/FB:1A/FC:1A/FD:1A/FE:1A/FF:1A";

// EBCDIC to ASCII

// Hollerith punched card code
// ANSI X3.26-1980 (R1991) Hollerith Punched Card Code
// American National Standard
// https://nvlpubs.nist.gov/nistpubs/Legacy/FIPS/fipspub14-1-May1980.pdf
// https://www.cs.umd.edu/~meesh/cmsc311/clin-cmsc311/Lectures/lecture6/ebcdic.html

//
const TO_ASCII = new Map(ASCII_TABLE.split("/").map((n) => n.split(":")));

// some additional rules
TO_ASCII.set("61", "2F");

const FROM_ASCII = new Map();
for (let [fromHex, toHex] of TO_ASCII.entries()) {
  FROM_ASCII.set(toHex, fromHex);
}

export const decimalPairToHex = (a, b) =>
  a.toString(16).toUpperCase() + b.toString(16).toUpperCase();
export const decimalToHex = (n) =>
  n.toString(16).toUpperCase().padStart(2, "0");
export const hexToDecimal = (hex) => parseInt(hex, 16);
export const decimalToBinary = (n) => n.toString(2).padStart(8, "0");

const blockIndexOf = (x, y) => {
  if (x >= 0 && x <= 7 && y >= 0 && y <= 8) {
    return 0; // top left
  } else if (x >= 0 && x <= 7 && y >= 9 && y <= 15) {
    return 1; // bottom left
  } else if (x >= 8 && x <= 15 && y >= 0 && y <= 9) {
    return 2; // top right
  } else if (x >= 8 && x <= 15 && y >= 10 && y <= 15) {
    return 3; // bottom right
  } else {
    throw new Error("invalid position");
  }
};

const zonePunchesTop = [
  "12-9",
  "11-9",
  "0-9",
  "9",
  "12-0-9",
  "12-11-9",
  "11-0-9",
  "12-11-0-9",
  "12-0",
  "12-11",
  "11-0",
  "12-11-0",
  "12",
  "11",
  "0",
  "",
];
const zonePunchesBottom = [
  "12-9",
  "11-9",
  "0-9",
  "9",
  "12",
  "11",
  "0",
  "",
  "12-0",
  "12-11",
  "11-0",
  "12-11-0",
  "12-0-9",
  "12-11-9",
  "11-0-9",
  "12-11-0-9",
];
const digitPunchesLeft = [
  "8-1",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "8-1",
  "8-2",
  "8-3",
  "8-4",
  "8-5",
  "8-6",
  "8-7",
];
const digitPunchesRight = [
  "8-1",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "8-2",
  "8-3",
  "8-4",
  "8-5",
  "8-6",
  "8-7",
];

const blocks = [
  [zonePunchesTop, digitPunchesLeft],
  [zonePunchesBottom, digitPunchesLeft],
  [zonePunchesTop, digitPunchesRight],
  [zonePunchesBottom, digitPunchesRight],
];

// there are several special codes that 'override' the
// defined pattern rules
// prettier-ignore
const codes = {
  "00": "12-0-9-8-1",
  "10": "12-11-9-8-1",
  "20": "11-0-9-8-1",
  "30": "12-11-0-9-8-1",
  "40": "",
  "50": "12",
  "60": "11",
  "70": "12-11-0",
  "C0": "12-0",
  "D0": "11-0",
  "E0": "0-8-2",
  "F0": "0",
  "61": "0-1",
  "E1": "11-0-9-1",
  "6A": "12-11",
}

export function punchesOf(dec) {
  if (typeof dec === "string") dec = hexToDecimal(dec);
  const hex = decimalToHex(dec).toUpperCase();

  // check if special condition
  if (hex in codes) return codes[hex];

  const [dec0, dec1] = hex.split("").map((n) => hexToDecimal(n));

  // get data for given block
  const [zonePunchTable, digitPunchTable] = blocks[blockIndexOf(dec0, dec1)];

  // the zone punch column is determined by first hex digit value (decimal)
  const zonePunches = zonePunchTable[dec0];
  // the digit punch row is determined by second hex digit value (decimal)
  const digitPunches = digitPunchTable[dec1];

  const punches = [zonePunches, digitPunches].filter(Boolean).join("-");
  return punches;
}

export const EMPTY = "40";

export function EBCDIC_to_ASCII(hex, opts = {}) {
  if (typeof hex === "number") hex = decimalToHex(hex);
  hex = hex.toUpperCase();
  const result = TO_ASCII.get(hex);
  if (result == null || result == "1A") return null;
  const dec = hexToDecimal(result);
  if (opts.printable) {
    // skip non-printable characters
    if (dec < 32 || dec > 126) return null;
  }
  return String.fromCharCode(dec);
}

export function ASCII_to_EBCDIC(hex) {
  if (typeof hex === "number") hex = decimalToHex(hex);
  hex = hex.toUpperCase();
  const result = FROM_ASCII.get(hex);
  if (result == null) return "1A";
  return result;
}
